export enum SEARCH_RESULT {
  NON_EXIST = 0,
  EXIST = 1
}

export enum CATE_CATEGORY {
  PARTNER = 0,
  NORMAL = 1,
  SHARE = 2
}

export enum RECOMMAND_CATEGORY {
  NON_RECOMMAND = 0,
  RECOMMAND = 1
}

export enum BANNER_POSITION_CATEGORY {
  TOP = 'top'
}

export enum SHARE_EXTEND {
  NON_EXTEND = 0,
  EXTEND = 1
}
